import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import moment from 'moment'
import {Row, Col, Tabs, Tab, Button, ButtonToolbar} from 'react-bootstrap'
import {mediaQuery} from '../../core/browser'
import extract from '../../core/extract'
import {connectForm, nodeHasValue} from '../../core/redux/form'
import SearchBar from '../../core/components/SearchBar'
import TypeaheadBar, {matcher} from '../../core/components/TypeaheadBar'
import Tags from '../../core/components/Tags'
import Tag from '../../core/components/Tag'
import Icon from '../../core/components/Icon'
import DayRangePicker from '../../core/components/DayRangePicker'
import ButtonToggle from '../../core/components/ButtonToggle'
import {Criteria} from '../models'
import {DEFAULT_TICKET_QUERY, CRITERIA_UPDATED, loadTicketStream} from '../actions'
import i18n from '../i18n'
import style from './TicketSearchBar.less'

function isActive(source, identify) {
    return (item) => {
        const id = identify(item)
        return source.find((i) => identify(i) == id) != null
    }
}

class TicketSearchBar extends Component {
    static propTypes = {
    }

    _search(event) {
        const {dispatch, criteria, location} = this.props

        if (event) {
            event.preventDefault()
        }

        return dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...criteria})).then(() => {
            if (['/tickets', '/tickets/dashboard'].indexOf(location.pathname) < 0) {
                return dispatch(push('/tickets'))
            }
        })
    }

    _searchOnKeyPress(event) {
        if (event.key == 'Enter') {
            const {dispatch, criteria, location} = this.props
            
            return dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...criteria})).then(() => {
                if (['/tickets', '/tickets/dashboard'].indexOf(location.pathname) < 0) {
                    return dispatch(push('/tickets'))
                }
            })
        }
    }

    render() {
        const {dispatch, form, criteria, aggregations} = this.props

        const locationSource = matcher({
            source: aggregations.locations,
            identify: (l) => l.value
        })

        const companySource = matcher({
            source: aggregations.clientCompanies,
            identify: (c) => c.label
        })

        const agencySource = matcher({
            source: aggregations.agencies,
            identify: (a) => a.label
        })

        const patrimonySource = matcher({
            source: aggregations.patrimonies,
            identify: (p) => p.label
        })

        const callPurposeSource = matcher({
            source: aggregations.callPurposes,
            identify: (p) => p.value
        })

        const tabTitle = (label, icon) => (
            <span className={style.tabTitle}>
                <Icon icon={icon} size='sm' />
                {label}
            </span>
        )

        const displayPatrimony = (patrimony) => (
            <span>
                <span>{patrimony.ref} ({patrimony.count})</span>
                <small>{patrimony.label}</small>
            </span>
        )

        const footer = nodeHasValue(form.status, form.intervention, form.location, form.clientCompany, form.agency, form.patrimony, form.callPurpose, form.from, form.to) && (
            <div className={style.footer}>
                <h4>
                    {i18n.searchSummary}
                    <small>
                        <Tag
                            display={(d) => moment(d).format(i18n.dateFormat.from)}
                            {...form.from()} />
                        <Tag
                            display={(d) => moment(d).format(i18n.dateFormat.to)}
                            {...form.to()} />
                        <Tag
                            display={(s) => extract(i18n.statusEnum, s)}
                            {...form.status()} />
                        <Tag
                            display={(i) => extract(i18n.ticketsInterventionEnum, i && 'with' || 'without' )}
                            {...form.intervention()} />
                    </small>
                </h4>
                <Tags
                    label={i18n.company + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(c) => c.label}
                    active={isActive(aggregations.clientCompanies, (c) => c.value)}
                    {...form.clientCompany()} />
                <Tags
                    label={i18n.agency + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(a) => a.label}
                    active={isActive(aggregations.agencies, (a) => a.value)}
                    {...form.agency()} />
                <Tags
                    label={i18n.patrimony + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(p) => p.ref}
                    active={isActive(aggregations.patrimonies, (p) => p.value)}
                    {...form.patrimony()} />                    
                <Tags
                    label={i18n.callPurpose + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(p) => p.value}
                    active={isActive(aggregations.callPurposes, (p) => p.value)}
                    {...form.callPurpose()} />
                <Tags
                    label={i18n.city + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(l) => l.value}
                    active={isActive(aggregations.locations, (l) => l.value)}
                    {...form.location()} />
            </div>
        )

        return (
        	<SearchBar
                footer={footer}
                placeholder={extract(i18n.searchStream, mediaQuery())}
                onClick={(e) => this._search(e)}
                onKeyPress={(e) => this._searchOnKeyPress(e)}
                {...form.fullText()}>
                <Row>
                    <Col sm={8}>
                        <div className={style.content}>
                            <Tabs
                                bsStyle='cursors'
                                defaultActiveKey={1}
                                justified>
                                <Tab
                                    title={tabTitle(i18n.company, 'customer')}
                                    eventKey={1}>
                                    <TypeaheadBar split
                                        source={companySource}
                                        identify={(a) => a.value}
                                        display={(a) => a.label + ' (' + a.count + ')'}
                                        placeholder={extract(i18n.searchCompany, mediaQuery())}
                                        {...form.clientCompany()} />
                                </Tab>
                                <Tab
                                    title={tabTitle(i18n.agency, 'file')}
                                    eventKey={2}>
                                    <TypeaheadBar split
                                        source={agencySource}
                                        identify={(a) => a.value}
                                        display={(a) => a.label + ' (' + a.count + ')'}
                                        placeholder={extract(i18n.searchAgency, mediaQuery())}
                                        {...form.agency()} />
                                </Tab>
                                <Tab
                                    title={tabTitle(i18n.patrimony, 'buildingz')}
                                    eventKey={3}>
                                    <TypeaheadBar split
                                        source={patrimonySource}
                                        identify={(p) => p.value}
                                        display={displayPatrimony}
                                        placeholder={extract(i18n.searchPatrimony, mediaQuery())}
                                        {...form.patrimony()} />
                                </Tab>
                                <Tab
                                    title={tabTitle(i18n.date, 'calendar')}
                                    eventKey={4}>
                                    <DayRangePicker
                                        {...form(['from', 'to'])} />
                                </Tab>
                                <Tab
                                    title={tabTitle(i18n.callPurposezz, 'phone-question')}
                                    eventKey={5}>
                                    <TypeaheadBar split
                                        source={callPurposeSource}
                                        identify={(p) => p.value}
                                        display={(p) => p.value + ' (' + p.count + ')'}
                                        placeholder={extract(i18n.searchCallPurpose, mediaQuery())}
                                        {...form.callPurpose()} />
                                </Tab>
                                <Tab
                                    title={tabTitle(i18n.city, 'location')}
                                    eventKey={6}>
                                    <TypeaheadBar split
                                        source={locationSource}
                                        identify={(l) => l.value}
                                        display={(l) => l.value + ' (' + l.count + ')'}
                                        placeholder={extract(i18n.searchCity, mediaQuery())}
                                        {...form.location()} />
                                </Tab>
                            </Tabs>
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className={style.side}>
                            <h4>Affinez votre recherche</h4>
                            <div className={style.sideContent}>
                                <ButtonToggle
                                    {...form.status()}>
                                    <ButtonToolbar>
                                        <Button
                                            value='OPENED'>
                                            <div>
                                                <Icon icon={'ticket-opened'} size='xl' />
                                            </div>
                                            <p>{i18n.ticketsStatusEnum.opened}</p>
                                        </Button>
                                        <Button
                                            value='CLOSED'>
                                            <div>
                                                <Icon icon={'ticket-closed'} size='xl' />
                                            </div>
                                            <p>{i18n.ticketsStatusEnum.closed}</p>
                                        </Button>
                                    </ButtonToolbar>
                                </ButtonToggle>
                                <ButtonToggle
                                    {...form.intervention()}>
                                    <ButtonToolbar>
                                        <Button
                                            value={true}>
                                            <div>
                                                <Icon icon={'ticket-with-intervention'} size='xl' />
                                            </div>
                                            <p>{i18n.ticketsInterventionEnum.with}</p>
                                        </Button>
                                        <Button
                                            value={false}>
                                            <div>
                                                <Icon icon={'ticket-without-intervention'} size='xl' />
                                            </div>
                                            <p>{i18n.ticketsInterventionEnum.without}</p>
                                        </Button>
                                    </ButtonToolbar>
                                </ButtonToggle>
                            </div>
                        </div>
                    </Col>
                </Row>
        	</SearchBar>
        )
    }
}

TicketSearchBar = connectForm({
    target: 'criteria',
    schema: Criteria.schema,
    action: CRITERIA_UPDATED
})(TicketSearchBar)

TicketSearchBar = connect((state) => ({
    location: state.router.location,
    criteria: state.ticket.criteria,
    aggregations: state.ticket.aggregations
}))(TicketSearchBar)

export default TicketSearchBar


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketSearchBar.js